// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_lyJ","cls2":"FocusedNav-cls2_d9O FocusedNav-cls1_lyJ"};